import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import { DueOut, PersonDetails } from '../../assets/ts/data/dueout/dueout'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import { toShortDateString } from '../../assets/ts/general/general'
import { SelectionContext } from '../../store/selection-context-provider'
import { DUEOUT_STATUS } from '../../utils/constants/global-constants'
import InputCheckbox from '../../utils/controls/input-checkbox'

type Props = {
  dueout: DueOut
}
const CustomerDashboardDueOutsTableRow = ({ dueout }: Props) => {

  const selection = useContext(SelectionContext)
  const guid = dueout.DueOutGUID ?? ''

  return (
    <>
      <tr>
        <th className='checkbox'>
          <InputCheckbox
            formClassName='form-horizontal font-0'
            inputProps={{
              checked: selection.keyIsSelected(guid),
              id: guid,
              label: `checkbox-${dueout.DueOutID}`,
              name: 'Input Check',
              type: 'checkbox',
            }}
            onChange={(e) =>
              selection.handleSingleCheckboxChange(e, guid)
            }
          />
        </th>
        <th aria-label='ID' tabIndex={0}>
          <Link
            className='links'
            state={{ prevPath: "/" }}
            title={`${dueout.DueOutID}`}
            to={`${ROUTE_TYPE}dueoutdetailview/${guid}`}
          >
            {defaultToEmptyString(dueout.DueOutID)}
          </Link>
        </th>
        <td aria-label='Section' tabIndex={0}>
          {defaultToEmptyString(dueout['Section/MetadataValue'])}
        </td>
        <td aria-label='Category' tabIndex={0}>
          {defaultToEmptyString(dueout['Category/MetadataValue'])}
        </td>
        <td aria-label='Customer Name' tabIndex={0}>
          {defaultToEmptyString((dueout.Customer as PersonDetails)?.properties?.defaultDisplay)}
        </td>
        <td aria-label='Due Date' tabIndex={0}>
          {dueout.DueDate ? defaultToEmptyString(toShortDateString(dueout.DueDate)) : ''}
        </td>
        <td aria-label='Created By' tabIndex={0}>
          {defaultToEmptyString(dueout.ServicingBy)}
        </td>
        <td aria-label='Date Created' tabIndex={0}>
          {dueout.ItemCreated ? defaultToEmptyString(toShortDateString(dueout.ItemCreated)) : ''}
        </td>
        <th aria-label='Status'
          data-table-status={DUEOUT_STATUS[dueout.StatusCode ?? '']?.colorCode}
          tabIndex={0}
        >
          {defaultToEmptyString(dueout['Status/StatusDescription'])}
        </th>
      </tr>
      <tr>
        <th colSpan={12}>
          <Link
            className='links'
            state={{ prevPath: "/" }}
            title={dueout.Subject}
            to={`${ROUTE_TYPE}dueoutdetailview/${dueout.DueOutGUID}`}
          >
            {defaultToEmptyString(dueout.Subject)}
          </Link>
        </th>
      </tr>
    </>
  )
}

export default CustomerDashboardDueOutsTableRow
